// ** React Imports
import { useContext, useMemo } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// ** Hooks
import useQuery from "hooks/useQuery";

// ** Utils & Helpers
import { searchSexCustomSort } from "utils/searchSexCustomSort";

// ** Context
import authContext from "contexts/authContext";

// #####################################################

const useNearbySexFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const isAuth = useContext(authContext);

	const query = useQuery();
	const { sex: sexUrl } = query || {};

	const userSearchSex = useSelector((state) => state.globalUser.searchSex);

	const language = useSelector((state) => state.globalCommon.language);

	const sexFinal = useMemo(() => {
		if (sexUrl) {
			return sexUrl;
		} else if (sexUrl === "") {
			return "";
		} else if (isAuth && userSearchSex) {
			return [...userSearchSex].sort(searchSexCustomSort).join("-");
		}
		return ""; //"woman-man-couple-transsexual";
	}, [sexUrl, userSearchSex, isAuth, language]);

	// ** Filtr - Płeć
	const sexFilterData = useMemo(() => {
		const sexItemsText = () => {
			return sexFinal
				? sexFinal
						.split("-")
						.map((sexItem) => t(`common:sexOptions.${sexItem}`))
						.join(", ")
				: null;
		};
		return sexFinal /*&& sexFinal !== "woman-man-couple-transsexual"*/
			? {
					label: t("common:gender"),
					selected: sexItemsText(),
			  }
			: null;
	}, [sexFinal, language]);

	// #####################################################

	return sexFilterData;
};

// #####################################################

export default useNearbySexFilterData;

// #####################################################
